"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO8601_week_no = exports.isSameDay = exports.isTodaysDate = exports.getDaysInMonth = exports.getDatesInMonth = exports.formattedStartAndEndTime = exports.getCurrentMonth = exports.getCurrentYear = exports.unixTimeToDate = exports.getYearsPlusMinus = exports.YYYY_MM_ddT_HH_mm_toDate = exports.dateToYYYY_MM_DD = exports.isWithin = exports.getDate = exports.getWeekDayName = exports.getWeekDay = exports.getMonthName = void 0;
function getMonthName(month) {
    return monthName[month - 1];
}
exports.getMonthName = getMonthName;
function getWeekDay(year, month, day) {
    return new Date(year, month, day).getDay();
}
exports.getWeekDay = getWeekDay;
function getWeekDayName(year, month, day) {
    return dayName[getWeekDay(year, month, day)];
}
exports.getWeekDayName = getWeekDayName;
function getDate(year, month, day) {
    return new Date(year, month, day);
}
exports.getDate = getDate;
function isWithin(year, month, day, start, end) {
    if (isSameDay(year, month, day, start)) {
        return true;
    }
    var date = new Date(year, month, day);
    if (start < date && end > date) {
        return true;
    }
    return false;
}
exports.isWithin = isWithin;
var dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var monthName = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
function dateToYYYY_MM_DD(date) {
    var dateUTC = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return dateUTC.toISOString().slice(0, 10);
}
exports.dateToYYYY_MM_DD = dateToYYYY_MM_DD;
function YYYY_MM_ddT_HH_mm_toDate(dateString) {
    return new Date(dateString);
}
exports.YYYY_MM_ddT_HH_mm_toDate = YYYY_MM_ddT_HH_mm_toDate;
function getYearsPlusMinus() {
    var years = [];
    var currentDate = new Date();
    for (var i = currentDate.getFullYear() - 5; i < currentDate.getFullYear() + 5; i++) {
        years.push(i);
    }
    return years;
}
exports.getYearsPlusMinus = getYearsPlusMinus;
function unixTimeToDate(unixTime) {
    return new Date(unixTime);
}
exports.unixTimeToDate = unixTimeToDate;
function getCurrentYear() {
    return new Date().getFullYear();
}
exports.getCurrentYear = getCurrentYear;
function getCurrentMonth() {
    return new Date().getMonth();
}
exports.getCurrentMonth = getCurrentMonth;
function formattedStartAndEndTime(start, end) {
    var startDate = new Date(start);
    var endDate = new Date(end);
    return startDate.toTimeString().substr(0, 5) + " - " + endDate.toTimeString().substr(0, 5);
}
exports.formattedStartAndEndTime = formattedStartAndEndTime;
function getDatesInMonth(year, month) {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
}
exports.getDatesInMonth = getDatesInMonth;
function getDaysInMonth(year, month) {
    // Get day 0 of next month, that will be the last day of this month
    var lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    var arr = Array(lastDayOfMonth);
    for (var i = 0; i < lastDayOfMonth; i++) {
        arr[i] = i + 1;
    }
    return arr;
}
exports.getDaysInMonth = getDaysInMonth;
function isTodaysDate(year, month, day) {
    var today = new Date();
    return isSameDay(year, month, day, today);
}
exports.isTodaysDate = isTodaysDate;
function isSameDay(year, month, day, date) {
    if (year === date.getFullYear() && month === date.getMonth() && day === date.getDate()) {
        return true;
    }
    else {
        return false;
    }
}
exports.isSameDay = isSameDay;
function ISO8601_week_no(year, month, day) {
    var monthIndex = month - 1;
    var dt = new Date(year, monthIndex, day);
    var tdt = new Date(dt.valueOf());
    var dayn = (dt.getDay() + 6) % 7;
    tdt.setDate(tdt.getDate() - dayn + 3);
    var firstThursday = tdt.valueOf();
    tdt.setMonth(0, 1);
    if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
    }
    return 1 + Math.ceil((firstThursday - tdt.valueOf()) / 604800000);
}
exports.ISO8601_week_no = ISO8601_week_no;
//# sourceMappingURL=date-utils.js.map